import { authService } from "./authService";

interface IFetchParams {
  endpointUrl: string;
  baseUrl?: string;
  httpVerb?: HttpVerbs;
  headers?: Record<string, string>;
  orgId?: string;
}

enum HttpVerbs {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH'
}

const baseFetch = async <T>(fetchParams: IFetchParams): Promise<Error | T> => {
  try {
    const response = await fetch(
      `${fetchParams.baseUrl ?? process.env.REACT_APP_API_URL}${
        fetchParams.endpointUrl
      }`,
      {
        method: fetchParams.httpVerb ?? HttpVerbs.GET,
        headers: {
          ...fetchParams.headers, 
          Authorization: `Bearer ${await authService.getAccessToken()}`,
          "OrganisationId": fetchParams.orgId ?? "",
        },
      }
    );

    if (!response.ok) {
      return new Error(
        `HTTP error! Status: ${response.status}: ${response.statusText}`
      );
    }

    return await response.json();
  } catch (error) {
    return new Error(`Fetch error: ${error}`);
  }
};

export { baseFetch, HttpVerbs };

